<mat-sidenav-container class="example-container" [hasBackdrop]="isMobile" >
  <mat-sidenav [mode]="sidenavMode" position="start" [(opened)]="opened" [disableClose]="!isMobile"  [@minify]="mini">
      <app-sideBar [userData]="userData" [mini]="mini" [miniPanel]="miniPanel"></app-sideBar>
  </mat-sidenav>
  <mat-sidenav-content  
    class="flex column"
    #drawerCont
    id="main-panel-new"
    [@panel]="{ value: miniPanel, params: { scale: cssVar, move: cssVar2 } }"
  >
     
      <div id="content_container" >
        <div id="toggle" class="flex center-vr" *ngIf="!mobileChat">
          <div (click)="toggleSidebarSize()" class="toggleSidebarToggle" id="toggle-btn" *ngIf="!isMobile">
            <i class="fa-light fa-bars"></i>
          </div>
          <button (click)="toggleSidebar()" id="mobile-toggle-btn" *ngIf="isMobile">
            <i class="fa-light fa-bars" ></i>
          </button>
          <div id="navbar-brand"  *ngIf="title$ | async as title">{{ title }}</div>
          <div class="createTicketContainer">
            <button class="home365-button createTicketButton flex center-vr" [ngClass]="{'home365-mobile-button mobileCreateTicketButton': isMobile}" (click)="createTicket()">
              <i class="fa-light fa-circle-question"></i>
              <span *ngIf="!isMobile" >{{'GENERAL_TEXTS.CREATE_TICKET_BUTTON_TEXT' | translate}}</span> 
            </button>
          </div>
        </div>
        <section id="main_content" class="flex-1 flex column" [ngClass]="{'mobileChat_main_content' : mobileChat}">
          <!-- <div class="home365-card"> -->
            <router-outlet></router-outlet>
          <!-- </div> -->
          
        </section>
      </div>
  </mat-sidenav-content>
</mat-sidenav-container>


<div class="spinnerBox" *ngIf="loading">
  <home365-loader [white]="false" [size]="'xxl'"></home365-loader>
</div>